// Rails' per-session CSRF token, as rendered into the layout by `csrf_meta_tags`.
// Every hand-written `fetch` to a ported JSON route has to send it: those controllers
// run `protect_from_forgery with: :null_session`, so a token-less POST is anonymous and
// comes back 401 instead of doing the thing.
export function csrfToken(): string {
  return (
    document
      .querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.getAttribute('content') ?? ''
  );
}
